export default __webpack_public_path__ + "static/media/onboardingAsideBg.3d202dff.png";